import { useAuth } from './useAuth'

/**
 * Returns a `can(permKey)` function that checks the current user's effective permissions.
 * Also exposes `role`, `isAdmin`, `isReviewer`.
 *
 * Usage:
 *   const { can, isAdmin } = usePermissions()
 *   if (can('can_edit_fields')) { ... }
 */
export function usePermissions() {
  const { user, can } = useAuth()
  return {
    can,
    role:       user?.role || null,
    isAdmin:    user?.role === 'admin',
    isReviewer: user?.role === 'admin' || user?.role === 'reviewer',
  }
}
